import { render, staticRenderFns } from "./jydz.vue?vue&type=template&id=1ed775e5&scoped=true&"
import script from "./jydz.vue?vue&type=script&lang=js&"
export * from "./jydz.vue?vue&type=script&lang=js&"
import style0 from "./jydz.vue?vue&type=style&index=0&id=1ed775e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed775e5",
  null
  
)

export default component.exports